import React from 'react'
import RawCheckbox from '@mui/material/Checkbox'
import {FormControl, FormControlLabel, FormHelperText} from '@mui/material'
import {Controller, useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

const FormCheckbox = ({name, label, i18nCategory, defaultValue, error}) => {
    const {control} = useFormContext()
    const {t} = useTranslation()
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({field}) => (
                <FormControl error={!!error}>
                    <FormControlLabel
                        control={<RawCheckbox defaultChecked={defaultValue} {...field} />}
                        label={t(`${i18nCategory}.${label}`)}
                    />
                    {error?.message && (
                        <FormHelperText>{t(`error.${error?.message}`)}</FormHelperText>
                    )}
                </FormControl>
            )}
        />
    )
}

export default FormCheckbox
